<template>
  <div>
    <Head title="Pacientes" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
        Pacientes
      </h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="patients/list"
        no-data-label="Nenhum paciente cadastrado"
        no-result-label="Nenhum paciente encontrado"
      >
        <template #table.cell.content.patient_status="{ value, row }">
          <switch-input
            v-model="row.status"
            label-checked="Ativo"
            label-unchecked="Inativo"
            @click="changeStatus(row)"
          />
        </template>
        <template #grid.content.body.patient_status="{ value, row }">
          <switch-input
            v-model="row.status"
            label-checked="Ativo"
            label-unchecked="Inativo"
            @click="changeStatus(row)"
          />
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-3 gap-4">
            <Link :href="'patients/detail/' + row.id">
              <font-awesome-icon
                icon="fa-eye"
                class="text-green-600 text-lg cursor-pointer"
              />
            </Link>
            <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon
              icon="fa-pen-to-square"
              class="text-blue-500 text-lg cursor-pointer"
            /></span>
            <span
              v-if="user.role == 1"
              @click="openModalConfirmDelete(row)"
            ><font-awesome-icon
              icon="fa-trash-can"
              class="text-red-600 text-lg cursor-pointer"
            /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-3 gap-4">
            <Link :href="'patients/detail/' + row.id">
              <font-awesome-icon
                icon="fa-eye"
                class="text-green-600 text-lg cursor-pointer"
              />
            </Link>
            <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon
              icon="fa-pen-to-square"
              class="text-blue-500 text-lg cursor-pointer"
            /></span>
            <span
              v-if="user.role == 1"
              @click="openModalConfirmDelete(row)"
            ><font-awesome-icon
              icon="fa-trash-can"
              class="text-red-600 text-lg cursor-pointer"
            /></span>
          </div>
        </template>

        <template #after.reload-button>
          <button
            v-if="user.role == 1"
            class="flex items-end font-roboto font-medium btn-blue uppercase"
            @click.prevent="openModalEdit({})"
          >
            <font-awesome-icon
              icon="fa-plus"
              class="text-white text-lg mr-0 lg:mr-2"
            /><span class="hidden lg:block">
              Adicionar Paciente</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete
      v-if="user.role == 1"
      ref="modalDelete"
      @confirm="reloadTable"
    />
    <modal-edit
      v-if="user.role == 1"
      ref="modalEdit"
      title="Paciente"
      url="patients"
      :item="{
        user: {},
        group: null,
        specialty: null,
        errors: { user: {} },
      }"
      @submit-form="reloadTable"
    >
      <template #form="{ item }">
        <text-input
          v-model="item.user.name"
          :error="item.errors[`user.name`]"
          class="lg:pr-6 w-full lg:w-1/2"
          label="Nome"
        />
        <mask-input
          v-model="item.user.cpf"
          mask="###.###.###-##"
          :error="item.errors[`user.cpf`]"
          class="mt-6 lg:mt-0 w-full lg:w-1/2"
          label="CPF"
        />
        <text-input
          v-model="item.user.email"
          :error="item.errors[`user.email`]"
          class="mt-6 lg:pr-6 w-full lg:w-1/2"
          label="E-mail"
        />
        <password-input
          v-model="item.user.password"
          :error="item.errors[`user.password`]"
          class="mt-6 w-full lg:w-1/2"
          label="Senha"
        />
        <vue-select-input
          v-model="item.group"
          :options="groups"
          :error="item.errors[`group.id`]"
          class="mt-6 lg:pr-6 w-full lg:w-1/2"
          label="Grupo"
          text="nenhum grupo grupo"
        />
        <text-input
          v-model="item.address"
          :error="item.errors.address"
          class="mt-6 w-full lg:w-1/2"
          label="Endereço"
        />
        
        <mask-input
          v-model="item.phone"
          mask="(##) #####-####"
          :error="item.errors[`phone`]"
          class="mt-6 w-full lg:w-1/2"
          label="Telefone" 
        />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import MaskInput from '@/Shared/MaskInput'
import VueSelectInput from '@/Shared/VueSelectInput'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    PasswordInput,
    MaskInput,
    VueSelectInput,
    Link,
  },
  layout: Layout,
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'patient_name',
          label: 'Nome',
          field: 'users.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes:
                        'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.name}`,
        },
        {
          uniqid: 'patient_cpf',
          label: 'CPF',
          field: 'users.cpf',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes:
                        'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.cpf}`,
        },
        {
          uniqid: 'patient_email',
          label: 'E-mail',
          field: 'users.email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes:
                        'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.email}`,
        },
        {
          uniqid: 'patient_group',
          label: 'Grupo',
          field: 'groups.name',
          visible:
                        usePage().props.value.auth.user.role == 1
                          ? true
                          : false,
          sortable: true,
          sortOrder: 'asc',
          classes:
                        'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => (row.group ? row.group.name : ''),
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    if (this.user.role == 1) {
      this.loadOptions()
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status
      this.$inertia.post('/patients/update-status', {
        id: item.id,
        status: item.status,
      })
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(
        item,
        `/patients/${item.id}`,
        `Deseja realmente excluir o paciente ${item.user.name}?`,
      )
    },
    openModalEdit(i) {
      let item = {
        id: i.id,
        address: i.address ?? '',
        status: i.status ?? true,
        phone: i.phone,
        user: {},
        group: null,
      }
      if (i.user) {
        item.user = {
          id: i.user.id,
          name: i.user.name,
          email: i.user.email,
          cpf: i.user.cpf,
        }
      }
      if (i.group) {
        item.group = {
          id: i.group.id,
          name: i.group.name,
        }
      }
      this.$refs.modalEdit.openModalEdit(item)
    },
    reloadTable() {
      this.loadTable = false
      setTimeout(() => (this.loadTable = true), 10)
    },
    async loadOptions() {
      await fetch('patients/get-options').then((res) => {
        res.json().then((json) => {
          this.groups = json.groups
        })
      })
    },
  },
}
</script>
